import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

/**
 * PrimeVue preset, isolated: with tokens.css, the only frontend file where a colour is written.
 * Every value here is a primitive of tokens.css, and each light-dark() pair equals the semantic
 * token it mirrors (test/preset.test.ts). PrimeVue v5 writes per-theme values as
 * light-dark(light, dark); the dark side is selected by DARK_MODE_SELECTOR.
 */
export const portalPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: "#f3f8fb",
      100: "#c4dcec",
      200: "#96c1dc",
      300: "#68a6cd",
      400: "#398abd",
      500: "#0b6fae",
      600: "#095e94",
      700: "#084e7a",
      800: "#063d60",
      900: "#042c46",
      950: "#031c2c",
      color: "light-dark(#0b6fae, #3fa3e0)",
      contrastColor: "light-dark(#ffffff, #08121c)",
      hoverColor: "light-dark(#095e94, #5fb4e8)",
      activeColor: "light-dark(#084e7a, #96c1dc)",
    },
    // Same order as Aura in both themes: 0 lightest, 950 darkest; dark backgrounds sit on 900 and 950
    surface: {
      0: "#ffffff",
      50: "#f4f6f8",
      100: "#e9edf1",
      200: "#e2e7ec",
      300: "#c5cdd5",
      400: "#97a2b2",
      500: "#76828f",
      600: "#56616d",
      700: "#3a444f",
      800: "#252d36",
      900: "#161b21",
      950: "#0f1216",
    },
    text: {
      color: "light-dark(#1b2530, #e8ecf2)",
      mutedColor: "light-dark(#56616d, #97a2b2)",
    },
    focusRing: {
      width: "2px",
      style: "solid",
      offset: "2px",
    },
  },
  components: {
    // Off state readable in both themes: track 3:1 against the header, handle 3:1 against the track
    toggleswitch: {
      root: {
        background: "{surface.500}",
        hoverBackground: "light-dark({surface.600}, {surface.400})",
      },
      handle: {
        background: "light-dark({surface.0}, {surface.900})",
        hoverBackground: "light-dark({surface.0}, {surface.900})",
      },
    },
  },
});

/** Dark theme selector, shared with theme/index.ts and index.html. */
export const DARK_MODE_SELECTOR = '[data-theme="sombre"]';
